export const ACCOUNT_LIST_CONSTANTS = {

};

const LIST_LEVEL_MAP = {

};

const GROUP_ABLE_LIST = {};

const LIST_WITH_VALUE = {
 
};

const READ_ONLY_LIST = [];

export const ACCOUNT_LIST_OPTIONS = Object.keys(ACCOUNT_LIST_CONSTANTS).map(
  (key) => ({
    name: ACCOUNT_LIST_CONSTANTS[key],
    value: ACCOUNT_LIST_CONSTANTS[key],
    maxLevel: LIST_LEVEL_MAP[key] ?? 1,
    allowGrouping: GROUP_ABLE_LIST[key]?.length,
    ...(!!GROUP_ABLE_LIST[key] && { groups: GROUP_ABLE_LIST[key] }),
    readOnly: READ_ONLY_LIST?.includes(key),
    ...(!!LIST_WITH_VALUE[key] && {
      valueLabel: LIST_WITH_VALUE[key]?.label,
      valueType: LIST_WITH_VALUE[key]?.type,
      defaults: LIST_WITH_VALUE[key]?.defaults,
    }),
  })
);
